import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as React from "react";
class KendoBaseComponent extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "destroyed", false);
  }
  componentDidMount() {
    this.exposeWidget();
    this.overrideDestroy();
  }
  componentWillUnmount() {
    if (!this.destroyed) {
      this.widgetDestroy.call(this.widgetInstance);
    }
    this.widgetInstance = null;
    this.exposeWidget();
  }
  exposeWidget() {
    if (this.props.widgetRef) {
      this.props.widgetRef(this.widgetInstance);
    }
  }
  overrideDestroy() {
    // We need an unbound method here!
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.widgetDestroy = this.widgetInstance.destroy;
    this.widgetInstance.destroy = () => {
      this.destroyed = !this.destroyed;
      this.widgetDestroy.call(this.widgetInstance);
    };
  }

  /**
   * Set id on HTML element
   *
   * The HTML element should be the DOM element that Kendo widget is "injected" into.
   *
   * @param {HTMLElement} htmlElement
   * @param {string} id
   */
  setId(htmlElement, id) {
    if (id) {
      htmlElement.id = id;
    }
  }
}
export default KendoBaseComponent;
//# sourceMappingURL=KendoBaseComponent.js.map
